// src/app/css.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { parse } from "css";

@Injectable({
  providedIn: "root",
})
export class CssService {
  constructor(private http: HttpClient) {}

  getCssVariables(url: string): Promise<{ [key: string]: string }> {
    const observable = this.http
      .get(url, { responseType: "text" })
      .pipe(map((cssContent) => this.extractCssVariables(cssContent)));
    return lastValueFrom(observable);
  }

  extractCssVariables(cssContent: string): { [key: string]: string } {
    const parsedCss = parse(cssContent);
    const variables: { [key: string]: string } = {};

    parsedCss.stylesheet.rules.forEach((rule: any) => {
      if (rule.selectors.includes(".nis-catalog")) {
        rule.declarations.forEach((declaration: any) => {
          if (declaration.property.startsWith("--")) {
            variables[declaration.property] = declaration.value;
          }
        });
      }
    });

    return variables;
  }
}
